module.exports = __webpack_public_path__ + "static/img/testimony (21).cd5e1221.jpg";